module.exports = __webpack_public_path__ + "img/goldregen-2020-007.c76cf67e.jpg";